import { put, takeLatest } from 'redux-saga/effects';
import { Notify } from '@flexisaf/flexibull2';
import { TOP_RIGHT, SUCCESS, INFO } from 'utils/constants';
import request from 'utils/request';
import urls from 'utils/config';
import { queryTransactionSuccess, queryTransactionFailure } from '../actions';
import transactionHistoryTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';


const { API_BASE_URL } = urls || {};

function* queryTransaction({ data }) {
  const { ref, cb } = data;
  const url = `${API_BASE_URL}/payments/status?ref=${ref}`;

  const response = yield request({
    method: 'get',
    url,
  });

  if (response.success) {
    yield put(queryTransactionSuccess(response.raw));
    if (response.raw.status === 'PENDING') {
      Notify('Transaction is still pending', {
        position: TOP_RIGHT,
        status: INFO,
      });
    } else {
      Notify('Transaction status updated successfully', {
        position: TOP_RIGHT,
        status: SUCCESS,
      });
    }
    cb();
  } else {
    yield put(
      queryTransactionFailure(
        'An error occured. Please reload the page to try again.'
      )
    );

    networkErrorHandler(response?.statusCode, 'Payment platform is currently down kindly retry later ');
  }
}

export function* onQueryTransaction() {
  yield takeLatest(
    transactionHistoryTypes.QUERY_TRANSACTION_START,
    queryTransaction
  );
}
